import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const missionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (missionRef.current) {
      observer.observe(missionRef.current);
    }

  }, [missionRef]);

  return (
    <div ref={missionRef} className='py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24 flex flex-col items-center'>
      <div className='w-full flex flex-col-reverse lg:flex-row justify-center items-center gap-8 lg:gap-12'>
        <div className='w-full lg:w-1/2'>
          <h1 className={`text-2xl sm:text-3xl md:text-4xl font-light tracking-wider mb-4 py-2 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
            DUBAI REAL ESTATE MARKET INSIGHTS
          </h1>
          <p className={`text-xs sm:text-sm md:text-base leading-relaxed text-gray-700 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
            Access comprehensive information about the current Dubai real estate market. Stay up-to-date with the latest developments regarding various communities, property prices, return on investment potential, and much more—all available at your fingertips with just a single click.
          </p>
          <div className='py-4 space-y-3 text-xs sm:text-sm md:text-base text-gray-800'>
            <div className='flex items-center'>
              <FontAwesomeIcon icon={faCheck} className='mr-3 text-bluColor flex-shrink-0' />
              <span>Recent monthly overview of real estate market</span>
            </div>
            <div className='flex items-center'>
              <FontAwesomeIcon icon={faCheck} className='mr-3 text-bluColor flex-shrink-0' />
              <span>Learn more about the top communities in Dubai</span>
            </div>
            <div className='flex items-center'>
              <FontAwesomeIcon icon={faCheck} className='mr-3 text-bluColor flex-shrink-0' />
              <span>Make informed decisions based on accurate information</span>
            </div>
          </div>
        </div>
        <img
          className={`w-full lg:w-1/2 rounded-lg shadow-sm object-cover transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`}
          src="https://dt7j04u1665qi.cloudfront.net/39-1-small.webp"
          srcSet="https://dt7j04u1665qi.cloudfront.net/39-1-small.webp 400w, https://dt7j04u1665qi.cloudfront.net/39-1-medium.webp 800w, https://dt7j04u1665qi.cloudfront.net/39-1-medium.webp 1200w"
          loading="lazy"
          alt="Market Insights"
        />
      </div>
    </div>
  );
};

export default About;
